module.exports = fox._r("images/bg/promotools_block_bg.jpg", __webpack_public_path__ + "images/bg/promotools_block_bg.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/bg/promotools_block_bg.jpg
// module id = 162
// module chunks = 5